import React, { Fragment } from "react";

const CertifiersUI  = () => (
  <section className="browser">
        <div className="sectionInner">
          <div className="certifiersText">Coming soon...</div>
        </div>
  </section>
);
  
export default CertifiersUI;